import { axiosInstance } from "@/utils/axiosInstance";
import {
  IGetCepResponse,
  IGetUserLocationResponse,
  IUpdateUserLocationRequest,
} from "./interfaces/user.interface";

export const UserService = {
  getCep: async (cep: string): Promise<IGetCepResponse> => {
    const res = await axiosInstance({
      method: "GET",
      url: `/seja-um-profissional/api/store/user/cep?q=${cep}`,
    });

    return res.data;
  },

  getUserLocation: async (
    authToken: string,
  ): Promise<IGetUserLocationResponse> => {
    const res = await axiosInstance({
      method: "GET",
      url: `/seja-um-profissional/api/store/user/location?authToken=${authToken}`,
    });

    return res.data;
  },

  updateUserLocation: async ({
    userId,
    radius,
    authToken,
    address_fields,
  }: IUpdateUserLocationRequest): Promise<void> => {
    await axiosInstance({
      method: "PATCH",
      url: "/seja-um-profissional/api/store/user/location",
      data: {
        authToken,
        radius,
        address_fields,
      },
    });
  },
};
